import React, { FC } from 'react';
import { CustomerDimension, JourneyFilterState } from '../../../../models/journey-explorer/journey-explorer';
import { COLORS, selectedCustomerValues, toggleCustomerValue } from '../journey-explorer-utils';
import { DimensionOptions, FilterGroup } from './filter-group';

export const CUSTOMER_GROUP_LABEL = 'Customer Filters';

interface CustomerFilterGroupProps {
	dimensions: CustomerDimension[];
	filterState: JourneyFilterState;
	open: boolean;
	search?: string;
	onToggle: () => void;
	onChange: (state: JourneyFilterState) => void;
}

const CustomerFilterGroup: FC<CustomerFilterGroupProps> = ({
	dimensions,
	filterState,
	open,
	search,
	onToggle,
	onChange,
}) => {
	const count = filterState.customer_filters.reduce((total, filter) => total + filter.values.length, 0);

	return (
		<FilterGroup
			label={CUSTOMER_GROUP_LABEL}
			color={COLORS.accent}
			count={count}
			open={open}
			search={search}
			onToggle={onToggle}
		>
			{dimensions.map((dimension) => (
				<DimensionOptions
					key={dimension.column}
					label={dimension.label}
					values={dimension.values}
					selected={selectedCustomerValues(filterState, dimension.column)}
					color={COLORS.accent}
					search={search}
					onToggle={(value) => onChange(toggleCustomerValue(filterState, dimension.column, value))}
				/>
			))}
		</FilterGroup>
	);
};

export default CustomerFilterGroup;
